// extracted by mini-css-extract-plugin
module.exports = {"link_button":"LinkButton_link_button__mc6_1"};